import { useTranslation } from "react-i18next";
import { AddNewEquipment } from "./AddNewEquipment";

interface IParams {
    onClick(): void;
    id?: string;
}

export const AddNewSIM = (props: IParams) => {
    const { onClick, id } = props;
    const { t } = useTranslation("cart");

    return <AddNewEquipment id={id} subtitle={t("addSimTooltip")} title={t("addSim")} onClick={onClick} />;
};
